<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col md="4">
          <b-input-group>
            <b-input-group-prepend>
              <label>Audit Date</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" placeholder="Start date"></b-form-input>
            <b-input-group-append>
              <span class="input-group-text">-</span>
            </b-input-group-append>
            <b-form-input v-model="tblData.tgl2" type="date" placeholder="Finish date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Remark</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.uraian" type="text" placeholder="Remark"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="3">
          <b-input-group>
            <b-input-group-prepend>
              <label></label>
            </b-input-group-prepend>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()">
              <i class="fa fa-refresh"></i> Apply Filter
            </b-button>
            <b-button class="btn btn-secondary mr-1" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear Filter
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <br />
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        @row-dblclicked="dbClicked"
        show-empty
      >
        <template v-slot:cell(startdate)="data">{{ data.item.startdate | moment("DD MMM YYYY") }}</template>
        <template v-slot:cell(enddate)="data">{{ data.item.enddate | moment("DD MMM YYYY") }}</template>
        <template v-slot:cell(progress)="data">{{data.item.progress}} &nbsp; %</template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
        <template v-slot:cell(row-details)="data">
          <b-card>
            <div class="report-wraper">
              <table style="width: 100%;">
                <thead>
                  <tr>
                    <th width="20px">No.</th>
                    <th width="180px">Item Code</th>
                    <th>Item Name</th>
                    <th width="300px">Type/Series</th>
                    <th>Posting Category</th>
                    <th>Shelf No</th>
                    <th width="100px" style="text-align:center;">
                      System
                      <br />Quantity
                    </th>
                    <th width="250px" style="text-align:center;">
                      Physical
                      <br />Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row,index) in detailLine[data.index]" :key="row.invOpnamDtlKey">
                    <td>{{index+1}}</td>
                    <td>{{row.partnumber}}</td>
                    <td>{{row.itemname}}</td>
                    <td>{{row.itemno+' | '+row.itemname}}</td>
                    <td>{{row.nmcategory}}</td>
                    <td>{{row.shelfNo}}</td>
                    <td style="text-align:center;">{{row.qtySystem}} {{row.invunitom}}</td>
                    <td style="text-align:center;">
                      <span v-if="(row.qtyOpname !== null)">{{row.qtyOpname}} {{row.invunitom}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <b-button size="sm" @click="data.toggleDetails">Hide Details</b-button>
          </b-card>
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols=3 label="Limit per page" style="margin-top:0 !important;">
            <b-form-select
              :options="[10, 20, 30, 50, 70, 90, 120]"
              :plain="true"
              v-model="tblData.limit"
              @change="refresh"
              size="sm"
              style="width:80px;"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-modal
      v-model="showForm"
      header-bg-variant="primary"
      title="Add - Stock Opname"
      size="lg"
      :centered="true"
      @ok="handleOk"
      ok-title="Save"
    >
      <b-form @submit.stop.prevent="save">
        <!-- <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend>
                <label>Stock asof date</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="model.stockdate"
                type="date"
                :state="!$v.model.stockdate.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>-->
        <!-- <b-row>
          <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend>
                <label>Store/Warehouse</label>
              </b-input-group-prepend>
              <b-form-select
                v-model="model.idStore"
                :plain="true"
                :options="Warehouse"
                :state="!$v.model.idStore.$error"
              >
                <template v-slot:first>
                  <option :value="null" disabled>-- Please select an warehouse --</option>
                </template>
              </b-form-select>
            </b-input-group>
          </b-col>
        </b-row>-->

        <b-row>
          <b-col lg="8">
            <b-input-group>
              <b-input-group-prepend>
                <label>Schedule</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="model.startdate"
                type="date"
                :state="!$v.model.startdate.$error"
              ></b-form-input>
              <b-input-group-append>
                <span class="input-group-text">-</span>
              </b-input-group-append>
              <b-form-input
                v-model="model.enddate"
                :min="minEnddate"
                type="date"
                :state="!$v.model.enddate.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-input-group>
          <b-input-group-prepend>
            <label>Remark/description</label>
          </b-input-group-prepend>
          <b-form-input v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>
        </b-input-group>
      </b-form>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-logistic {
}

.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  min-height: 100px;
  border: 1px solid silver;
  table {
    font-size: smaller;
    th {
      border: 1px solid silver;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
    td {
      border: 1px solid silver;
      padding: 0 10px;
      height: 25px;
    }

    td.tebal {
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: rgba(91, 192, 222, 0.2) !important;
      cursor: default;
    }

    tbody tr.selected {
      background-color: rgba(92, 184, 92, 0.2) !important;
      cursor: default;
    }

    tbody tr.beforeOpname {
      background-color: #f2dddd !important;
      cursor: default;
    }
  }
}
</style>


<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import inv from "../../apis/logistic_inv_in";
import opname from "../../apis/fa_opname";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      startdate: { required },
      enddate: { required },
      uraian: { required }
    }
  },
  components: { Loading },
  data() {
    return {
      showFilter: false,
      showForm: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      horizontal: true,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: {
        idStore: null
      },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: 'startdate',
        sortDesc: true
      },
      detailLine: [],
      tblFields: [
        {
          key: "startdate",
          thStyle: "width:110px",
          label: "Starting Date",
          sortable: true
        },
        {
          key: "enddate",
          thStyle: "width:110px",
          label: "Finish Date",
          sortable: true
        },
        {
          key: "uraian",
          label: "Remark/Description",
          sortable: true
        },

        {
          key: "totalItem",
          label: "Total Item",
          thStyle: "width:200px",
          sortable: true
        },
        {
          key: "audited",
          label: "Item Audited",
          thStyle: "width:200px"
        },
        {
          key: "rusak",
          label: "Item Broken",
          thStyle: "width:200px"
        },
        {
          key: "hilang",
          label: "Item Lost",
          thStyle: "width:200px"
        },
        {
          key: "progress",
          label: "Progress",
          thStyle: "width:100px"
        }
      ],
      dataList: {
        openStatus: dropdown.openClose
      },
      Warehouse: [],
      lineObj: {
        fields: [
          {
            key: "no",
            thStyle: "width:6px",
            label: "No"
            // sortable: true
          },
          {
            key: "partnumber",
            thStyle: "width:100px",
            label: "Item Code"
            // sortable: true
          },
          {
            key: "itemname",
            thStyle: "width:100px",
            label: "Item Name"
            // sortable: true
          },
          {
            key: "itemType",
            thStyle: "width:100px",
            label: "Type/Series"
            // sortable: true
          },
          {
            key: "nmcategory",
            thStyle: "width:100px",
            label: "Posting Category"
            // sortable: true
          },
          {
            key: "shelfNo",
            thStyle: "width:100px",
            label: "Shelf No"
            // sortable: true
          },
          {
            key: "qtySystem",
            thStyle: "width:100px",
            label: "System <br> Quantity"
            // sortable: true
          },
          {
            key: "qtyPhysic",
            thStyle: "width:100px",
            label: "Physical br Quantity"
            // sortable: true
          }
        ]
      }
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    maxStockDate() {
      return moment(new Date()).format("YYYY-MM-DD");
    },
    minEnddate() {
      return moment(this.model.startdate).format("YYYY-MM-DD");
    }
  },
  created: async function() {
    //   this.currency = await procure.currency();
    this.Warehouse = await inv.store();
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.isLoading = true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await opname.list(this.tblData);
      this.isLoading = false;
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.uraian = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.refresh();
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    add() {
      this.model = {
        stockdate: moment()
          .startOf("month")
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
        startdate: moment().format("YYYY-MM-DD"),
        idStore: null
      };
      this.showForm = true;
    },
    edit: function() {
      if (this.row.assetOpnamKey) {
        router.push({
          name: "fixedasset.opnamefrm",
          params: { assetOpnamKey: this.row.assetOpnamKey }
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.row.assetOpnamKey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function() {
      await pr.remove(this.row);
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.row && this.row._rowVariant) {
        delete this.row._rowVariant;
      }
      this.row = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    dbClicked(record, index) {
      if (record.assetOpnamKey) {
        router.push({
          name: "fixedasset.opnamefrm",
          params: { assetOpnamKey: record.assetOpnamKey }
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    showLineObj: async function(obj, idx, callback) {
      const data = await opname.detail(obj);
      const diffItems = data[1].filter(
        x => x.qtyOpname !== null && x.qtySystem !== x.qtyOpname
      );

      this.detailLine[idx] = diffItems;
      callback();
    },
    handleOk: function(evt) {
      evt.preventDefault();
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        this.save();
      }
    },
    save: async function() {
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        this.isLoading = true;
        try {
          this.model.assetOpnamKey = "";
          const row = await opname.save(this.model);
          this.isLoading = false;
          this.showForm = false;
          router.push({
            name: "fixedasset.opnamefrm",
            params: { assetOpnamKey: row.assetOpnamKey }
          });
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await opname.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    close() {
      router.push("/logistic/home");
    }
  }
};
</script>
